export const BUILT_IN_GRID_FIELDS = new Set([
  "__check__",
  "__reorder__",
  "__detail_panel_toggle__",
  "device",
  "groups",
  "address",
  "lastContact",
  "parking",
  "remark",
  "remainingRange",
]);

export function isBuiltInField(field: string): boolean {
  return BUILT_IN_GRID_FIELDS.has(field);
}
